import React from 'react';

import styles from './PlaybookBookcase.module.scss';

export const SystemTemplateBookEnd: React.FC = () => (
    <div className={styles.pottedPlantWrapper}>
        <div className={styles.pottedPlant} />
    </div>
);
